import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Component/PrivacyPage.css";
import logo from "../../src/assets/logo.png";
import Header from "./Header";
import translations from "./translation";
import Modal from './Modal';

const Privacy = () => {
    const [userID, setUserID] = useState("");
    const [isFollowSwitchOn, setIsFollowSwitchOn] = useState(true);
    const [isPrivacySwitchOn, setisPrivacySwitchOn] = useState(false);
    const [isShowRankingOn, setShowRankingOn] = useState(false);
    const [isProfanityFilterOn, setIsProfanityFilterOn] = useState(true); // New state
    const [username, setUsername] = useState('');
    const [posts, setPosts] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();
    const currentLanguage = localStorage.getItem("selectedLanguage") || "en";

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userResponse = await fetch(
                    `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem('user')}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                        },
                    }
                );

                if (userResponse.ok) {
                    const userResult = await userResponse.json();
                    console.log(userResult);
                    setUsername(userResult.attributes.username);
                    setIsFollowSwitchOn(userResult.attributes.AllowFollow);
                    setisPrivacySwitchOn(userResult.attributes.MakePrivate);
                    setShowRankingOn(userResult.attributes.ShowRanking);
                    setIsProfanityFilterOn(userResult.attributes.ProfanityFilter);
                    setUserID(userResult.id);
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);

    const handleFollowSwitchToggle = () => {
        const newStatus = !isFollowSwitchOn;
        setIsFollowSwitchOn(newStatus);
        updateSwitchStatus("AllowFollow", newStatus);
    };
    const updatePosts = async () => {
        fetch(`${process.env.REACT_APP_API_PATH}/posts?authorID=${userID}`,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + sessionStorage.getItem("token"),
                    },
                  })
                  .then((res) => res.json())
                  .then((result) => {
                    if (result) {
                        result[0].forEach(async (post) => {
                            try {
                                const postData = post;
                                const updatedAttributes = { ...postData.attributes, hidden: !isPrivacySwitchOn};
                                console.log(postData);
                                const patchResponse = await fetch(`${process.env.REACT_APP_API_PATH}/posts/${post.id}`, {
                                    method: "PATCH",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                                    },
                                    body: JSON.stringify({
                                        attributes: updatedAttributes,
                                    }),
                                });
                    
                                if (!patchResponse.ok) {
                                    throw new Error('Failed to update switch status');
                                }
                    
                                const result = await patchResponse.json();
                                console.log('Switch status updated successfully:', result);
                            } catch (error) {
                                console.error('Error updating switch status:', error);
                                alert("Failed to update switch status");
                            }
                        })
                    }
                    })
                  .catch((err) => {
                    console.log("ERROR loading posts");
                  });
    }
    const handlePrivacySwitchToggle = () => {
        const newStatus = !isPrivacySwitchOn;
        setisPrivacySwitchOn(newStatus);
        updateSwitchStatus("MakePrivate", newStatus);
        updatePosts();
    };

    const handleShowRankingSwitchToggle = () => {
        const newStatus = !isShowRankingOn;
        setShowRankingOn(newStatus);
        updateSwitchStatus("ShowRanking", newStatus);
    };

    const handleProfanityFilterToggle = () => { // New function
        const newStatus = !isProfanityFilterOn;
        setIsProfanityFilterOn(newStatus);
        updateSwitchStatus("ProfanityFilter", newStatus);

    };

    const handleDeleteAccount = () => {
        fetch(
          `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem(
            "user"
          )}?relatedObjectsAction=delete`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
          .then(() => {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            navigate("/login")
            }
          )
      }
      
    const updateSwitchStatus = async (switchName, status) => {
        try {
            const userResponse = await fetch(`${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem("user")}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            if (!userResponse.ok) {
                throw new Error('Failed to fetch user data');
            }

            const userData = await userResponse.json();
            const updatedAttributes = { ...userData.attributes, [switchName]: status };

            const patchResponse = await fetch(`${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem("user")}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    attributes: updatedAttributes,
                }),
            });

            if (!patchResponse.ok) {
                throw new Error('Failed to update switch status');
            }

            const result = await patchResponse.json();
            console.log('Switch status updated successfully:', result);
        } catch (error) {
            console.error('Error updating switch status:', error);
            alert("Failed to update switch status");
        }
    };

    useEffect(() => {
        if (!sessionStorage.getItem("token")) {
            navigate("/login");
        }
    }, []);

    return (
        <>
            <Header />
            <div className="privacy-background">
                <div className="Privacy_container">
                    {/* <Link to="/profile" className="Privacy_container_back_button">
                        Back
                    </Link> */}
                    <h2 className="Privacy_container_h2">{translations[currentLanguage].privacy}</h2>
                    <div class="Privacy_container_2">
                        <p className="Privacy_container_2_p">{translations[currentLanguage].change_password}</p>
                        <Link to="/change-password" className="arrow_button">
                            {'>'}
                        </Link>'
                        
                    </div>
                    <div class="Privacy_container_2">
                        <p className="Privacy_container_2_delete" color="B90000">{translations[currentLanguage].delete_account}</p>
                        <button className="arrow_button2" onClick={() => setShowModal(true)}>{'>'}</button>
                        <Modal show={showModal} onClose={() => setShowModal(false)}>
                            <h1>{translations[currentLanguage].delete_account_message}</h1>
                            <div className="modal_buttons">
                            <button onClick={handleDeleteAccount} className="yes_button">{translations[currentLanguage].yes}</button>
                            <button onClick={() => setShowModal(false)} className="no_button">{translations[currentLanguage].no}</button>
                            </div>
                        </Modal>
                    </div>
                    <div class="Privacy_container_2">
                        <p className="Privacy_container_2_p">{translations[currentLanguage].make_private}</p>
                        <div className={`switch ${isPrivacySwitchOn ? 'switch-on' : ''}`} onClick={handlePrivacySwitchToggle} >
                            <div className="toggle"></div>
                        </div>
                    </div>
                    {/* <div class="Privacy_container_2">
                        <p className="Privacy_container_2_p">{translations[currentLanguage].allow_follow}</p>
                        <div className={`switch ${isFollowSwitchOn ? 'switch-on' : ''}`} onClick={handleFollowSwitchToggle} >
                            <div className="toggle"></div>
                        </div>
                    </div> */}
                    <div class="Privacy_container_2">
                        <p className="Privacy_container_2_p">{translations[currentLanguage].show_ranking}</p>
                        <div className={`switch ${isShowRankingOn ? 'switch-on' : ''}`} onClick={handleShowRankingSwitchToggle} >
                            <div className="toggle"></div>
                        </div>
                    </div>
                    <div className="Privacy_container_2">
                        <p className="Privacy_container_2_p">{translations[currentLanguage].profanity_filter}</p>
                        <div className={`switch ${isProfanityFilterOn ? 'switch-on' : ''}`} onClick={handleProfanityFilterToggle} >
                            <div className="toggle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};
export default Privacy;
